import React, { lazy, Suspense } from 'react';
import './css/Latest.css';
import { List, Row, Col, Spin, Modal, Button, Table, notification } from "antd";
import TileMovie from './TileMovie';
import { payMovieStripeApi, completePaymentApi, getUserHistoryApi,
  paymentMovieStatusApi, dateMonthTimeString, writeUserEventToDb } from './utils/ApiUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faHistory, faRetweet, faTimes } from '@fortawesome/free-solid-svg-icons';
import firebase from './utils/firebase';
import { COLORS } from './utils/Constants';
const StripePage = lazy(() => import("./Stripe.js"));

let paymentStatusValue = 0, topMovieId = 0, billingDetails = '', userId = 0;
let status = true, userObject = '', locatorName = '', currentCountry = '';
let tableHeader = [{ title: 'Movie', dataIndex: 'movie', fixed: 'left' }, { title: 'Release Date', dataIndex: 'release' },
{ title: 'Paid', dataIndex: 'paid' }, { title: 'Purchase Date', dataIndex: 'purchase' }, { title: 'Expiry Date', dataIndex: 'expiry' }];

const btn = <a target='_blank' style={{ color: COLORS.red }} rel='noopener noreferrer' href='https://docs.hit.movie/apps'>Download the TV Apps now</a>;
const iPhoneMessage  = "Hit.Movie currently does not work in iPhone browsers. Hit.Movie is designed for a large-screen experience at 4K cinematic quality. You can buy movies here and watch them on your TV or our Website.";

class Latest extends React.Component {
  state = { size: 'small', player: false, showHistory: false, modalPayment: 0, loaderFees: false, 
  userId: 0, stripeObj: '', tableHeader: [], tableData: [] };
  componentDidMount() {
    console.log('latest did mount');
    let windowUrl = window.location.href;
    if(windowUrl.includes('mymovies/paymentstatus')) {
      this.setState({ loaderFees: true });
      if(this.props.sessionValue) {
        this.myMoviesPaymentStatus(this.props.sessionValue);
      } else {
        let sessionValue = localStorage.getItem('localStorageSession') || '';
        this.myMoviesPaymentStatus(sessionValue);
      }
    }
  }
  componentDidUpdate() {
    if(this.props.userObject&&(!userObject)) {
      userObject = this.props.userObject;
      if(userObject.location) {
        currentCountry = userObject.location.country;
      }
    }
    if(userId==0&&this.props.userId) {
      userId = this.props.userId;
      this.setState({ userId: userId });
    }
  }
  onChange = e => {
    this.setState({ size: e.target.value });
  };
  writePayMovieEvent = (eventName, movieId, showPrice, apiStatus, apiResult, apiMessage) => {
    let basicInfo = this.props.basicInfo;
    console.log('write event basicInfo='+JSON.stringify(basicInfo));
    let analyticsObj = { eventName: eventName, userObject: userObject, movieId: movieId, price: showPrice, 
      apiStatus: apiStatus, apiResult: apiResult, apiMessage: apiMessage, timeStamp: Date.now(), ...basicInfo };
    writeUserEventToDb(userId, analyticsObj);
  }
  openPlayer = (uploadId, movieObj, isTrailer) => {
    if(navigator.userAgent&&navigator.userAgent.includes('iPhone')) {
      if(status) {
        status = false;
        notification.open({
          duration: 5,
          description: iPhoneMessage,
          btn,
          key: Date.now(),
          onClose: () => {
            status = true;
          }
        }); 
      }
    } else {
      console.log('movie player userId='+userId);
      let playerObjects = { uploadId: uploadId, userId: userId, movieObj: movieObj, isTrailer: isTrailer, sessionValue: this.props.sessionValue };
      this.props.openPlayer(playerObjects);
    }
  }
  showHideHistory = (value) => {
    if(value) {
      this.setState({ tableData: [], showHistory: false });
    } else {
      this.getMyHistory();
    }
  }
  getMyHistory = () => {
    this.setState({ loaderFees: true });
    let sessionValue = this.props.sessionValue;
    getUserHistoryApi(sessionValue)
    .then(response => {
      console.log('getUserHistoryApi data='+JSON.stringify(response));
      if(response.ok) {
        let responseObj = response.info;
        let moviesObj = responseObj.myMovies;
        let tableData = [];
        if(moviesObj&&moviesObj.length>0) {
          moviesObj.map((item, index) => {
            console.log('loading table item='+item);
            if(item.movieUpload) {
              tableData.push({ key: index, movie: item.movieUpload.movie.movieName, release: dateMonthTimeString(item.movieUpload.movieReleaseDate), 
                paid: item.purchasePrice, purchase: dateMonthTimeString(item.purchaseTime), expiry: dateMonthTimeString(item.expiryTime) });
            }
          });
          console.log('mymoviesObj='+JSON.stringify(tableData));
        } 
        this.setState({ tableData: tableData, loaderFees: false, showHistory: true });
      } else {
        console.log('getUserHistoryApi fetching failed');
        this.setState({  tableData: [], loaderFees: false, showHistory: false });
      }
    })
    .catch((error) => {
      console.log('Error getUserHistoryApi data='+JSON.stringify(error));
      this.setState({ tableData: [], loaderFees: false, showHistory: false });
    });
  }
  payMovie = (movieObj, showPrice) => {
    console.log('movieObj='+JSON.stringify(movieObj));
    this.setState({ loaderFees: true });
    topMovieId = movieObj.id;
    locatorName = movieObj.azureStreamingLocatorName;
    let isIndia = movieObj.legalEntityCountry==='India';
    let sessionValue = this.props.sessionValue;
    payMovieStripeApi(sessionValue, movieObj.id, isIndia)
    .then(response => {
      console.log('pay movie data='+JSON.stringify(response));
      this.writePayMovieEvent('payMovieStripeApi', topMovieId, showPrice, response.status, response.ok, response.ok ? "payMovieStripe Api Success." : response.info);
      if(response.ok) {
        let info = response.info;
        console.log('payMovie StripeApi success='+JSON.stringify(info));
        let stripeObj = { movieName: movieObj.movie.movieName, showPrice: showPrice, publishableKey: info.publishableKey, clientSecret: info.clientSecret, enableCaptcha: info.enableCaptcha };
        firebase.database().ref("users/").child(userId).child("/address/").once("value", snapshot => {
          if(snapshot&&snapshot.val()) {
            console.log('firebase Billing Details');
            billingDetails = snapshot.val();
          }
          this.setState({ stripeObj: stripeObj, loaderFees: false });
        });
      } else {
        console.log('payMovie StripeApi failed');
        this.setState({ loaderFees: false });
      }
    })
    .catch((error) => {
      console.log('Error deleting like movie='+JSON.stringify(error));
      this.setState({ loaderFees: false });
    });
  }
  completePaymentFunction = () => {
    let sessionValue = this.props.sessionValue;
      completePaymentApi(sessionValue, topMovieId)
      .then(response => {
        console.log('completePaymentApi data='+JSON.stringify(response));
        if(response.ok) {
          console.log('completePaymentApi like success');
          this.setState({ modalPayment: 1, loaderFees: false });
          this.updateMovieResumeTime();
        } else {
          console.log('completePaymentApi like failed');
          this.setState({ modalPayment: 2, loaderFees: false });
        }
      })
      .catch((error) => {
        console.log('Error completePaymentApi movie='+JSON.stringify(error));
        this.setState({ modalPayment: 2, loaderFees: false });
      });
  }
  updateMovieResumeTime = () => {
    var updates = {};
    updates['resumeObject'] = { resumeTime: 0 };
    firebase.database().ref('users/'+userId+'/'+locatorName+'/'+currentCountry).update(updates);
  }
  myMoviesPaymentStatus = (sessionValue) => {
    paymentMovieStatusApi(sessionValue)
      .then(response => {
        console.log('paymentMovieStatusApi data='+JSON.stringify(response));
        if(response.ok) {
          let resObj = response.info;
          this.setState({ loaderFees: false });
          let payStatus = resObj.paymentstatus;
          if(payStatus==='Success') {
            this.setState({ modalPayment: 1 });
          }
          else if(payStatus==='Failed') {
            this.setState({ modalPayment: 2 });
          } else {
            if(paymentStatusValue<5) {
              paymentStatusValue++;
              setTimeout(
                () => { this.myMoviesPaymentStatus(sessionValue); }, 
                3000
              );
            }
          }
        } else {
          console.log('paymentMovieStatusApi fetchig failed!');
          this.setState({ loaderFees: false });
        }
      })
      .catch((error) => {
        console.log('Error loading paymentMovieStatusApi='+JSON.stringify(error));
        this.setState({ loaderFees: false });
      });
  }
  goToMovies = (value) => {
    console.log('going to my movies='+value);
    if(value) {
      this.setState({ loaderFees: true, stripeObj: '' });
      this.completePaymentFunction();  
    } else {
      this.setState({ loaderFees: true, stripeObj: '' });
      this.setState({ modalPayment: 2, loaderFees: false });
    }
  }
  setModal2Visible = (value) => {
    if(value) {
      this.setState({ modalPayment: 0 });
    } else {
      window.history.replaceState(null, null, "/mymovies");
      let sessionValue = this.props.sessionValue;
      this.props.setUrlToMyMovies(sessionValue);
      this.setState({ modalPayment: 0 });  
    }
  }
  render() {
    let scrWidth = window.innerWidth;
    let moviesList = this.props.movies;
    let historyList = this.state.history;
    let tableData = this.state.tableData;
    let windowUrl = window.location.href;
    let isMyMoviesPage = windowUrl.includes('mymovies');
    let tempMovieList = [], tempHistoryList = [];
    if(moviesList&&moviesList.length>0) {
      moviesList.map((item, index) => {
        // console.log('movie info='+JSON.stringify(item));
        let buyStatus = item.userPurchase ? true : false;
        let movieItem = item.upload;
        let expiryTime = item.userPurchase ? item.userPurchase.expiryTime : '';
        let purchaseTime = item.userPurchase ? item.userPurchase.purchaseTime : '';
        if(isMyMoviesPage) {
          buyStatus = true;
          expiryTime = item.expiryTime;
          purchaseTime = item.purchaseTime;
        }
        if(item.upload.demoMode) {
          buyStatus = true;
          expiryTime = '';
          purchaseTime = item.upload.movieReleaseDate;
        }
        tempMovieList.push({ movie: movieItem, buyStatus: buyStatus, currentCountry: item.userCurrentCountry, 
          expiryTime: expiryTime, purchaseTime: purchaseTime, index: index });
      });      
    }
    if(isMyMoviesPage) {
      if(historyList&&historyList.length>0) {
        historyList.map((item, index) => {
          let buyStatus = true;
          let movieItem = item.upload;
          let expiryTime = item.expiryTime;
          let purchaseTime = item.purchaseTime;
          tempHistoryList.push({ movie: movieItem, buyStatus: buyStatus, currentCountry: item.userCurrentCountry, 
            expiryTime: expiryTime, purchaseTime: purchaseTime, index: index+1 });
        });      
      }
    }
    let emptyContentHeight = isMyMoviesPage ? 200 : window.innerHeight-40;
    let isMovieList = moviesList.length>0 ? 100 : 0;
    let modalPaymentCode = this.state.modalPayment;
    let showHistory = this.state.showHistory;
    let isMobile = scrWidth<768;
    let tablePadding = '10%';
    let histroyText = 'Show History';
    if(showHistory) {
      histroyText = 'Hide History';
    }
    if(isMobile) {
      tablePadding = 0;
    }
    console.log('scrWidth='+scrWidth+'movie info='+(tempMovieList));
    return (
      <div>
        { isMovieList
          ?
          <div>
        { isMobile
        ?
        <Row justify='center'>
          <img className="custom2" src={require('./images/logo2.png')} alt='HIT' style={{ width: 125, height: 75, textShadow:'1px 3px 1px #9E9E9E', marginTop: -20, marginBottom: 20 }} />
          <Col span={24} style={{  }}>
            <List
              grid={{ gutter: 32, column: 1 }}
              dataSource={tempMovieList}
              renderItem={item => (
                <List.Item style={{ marginBottom: 0 }}>
                  <TileMovie movieObj={item.movie} openPlayer={this.openPlayer} expiryTime={item.expiryTime} buyStatus={item.buyStatus}
                  payMovie={this.payMovie} sessionValue={this.props.sessionValue} userCurrentCountry={item.currentCountry}
                  purchaseTime={item.purchaseTime} isVerified={this.props.isVerified} 
                  userId={this.state.userId} openIdentityPopup={this.props.openIdentityPopup} />
                </List.Item>
              )}
            />
          </Col>
        </Row>
        :
        <List
          grid={{ gutter: 16, column: 1 }}
          style={{ paddingLeft: 8, paddingRight: 8 }}
          dataSource={tempMovieList}
          renderItem={item => (
            <List.Item key={item.movie ? item.movie.id : ''}>
              <TileMovie movieObj={item.movie} openPlayer={this.openPlayer} expiryTime={item.expiryTime} buyStatus={item.buyStatus}
                payMovie={this.payMovie} sessionValue={this.props.sessionValue} userCurrentCountry={item.currentCountry}
                purchaseTime={item.purchaseTime} isVerified={this.props.isVerified}
                userId={this.state.userId} openIdentityPopup={this.props.openIdentityPopup} />
            </List.Item>
          )}
        />        
        }
        </div>
          :
          <div style={{ minHeight: emptyContentHeight, display: 'flex', justifyContent:'center', alignContent:'center' }}>
            <h1 className="emptyContent" style={{ flex:1, textAlign:'center', alignSelf:'center', fontSize: 20, opacity: 0.7 }}>
              {this.props.content}
            </h1>            
          </div>
        }
        { isMyMoviesPage
        ?
        <div style={{ display: 'flex', flexDirection: 'column', margin: 16 }}>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div onClick={() => { this.showHideHistory(showHistory) }} style={{ display: 'flex', cursor: 'pointer', width: 244, height: 44, background: COLORS.blue6a7a8a, borderRadius: 5 }}>
              <Row style={{ width: 240, height: 40, background: COLORS.blue2a3a4a, borderRadius: 3, margin: 2 }}>
                <div className='historyButton'>
                  <FontAwesomeIcon icon={faHistory} style={{ fontSize: 20, marginRight: 8 }} />
                  <p style={{ fontSize: 14, marginBottom: 0, textAlign:'left', fontFamily: 'OpenSans-Bold' }}>{histroyText}</p>
                </div>
              </Row>
            </div>
          </div>
          <div style={{ marginTop: 30, marginLeft: tablePadding, marginRight: tablePadding }}>
          { tableData.length>0
          ?
          <Table indentSize={16} bordered columns={tableHeader} dataSource={tableData} pagination={false} scroll={{ x: 800 }} />
          :
          <div/>
          }
          </div>
        </div>
        :
        <div />
        }
        <div style={{ height: isMovieList }}  />
        { this.state.loaderFees &&
          <div style={{ position: 'fixed', backgroundColor: 'rgba(10, 26, 42, 0.6)', top: 0, bottom: 0, left: 0, right: 0, zIndex: 9999 }}>
            <Spin size='large' style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
          </div>
        }
        <Modal className="stripeModal" width={ isMobile ? '100%' : 320 } centered={true} visible={this.state.stripeObj} maskClosable={false}
        onCancel={() => this.setState({ stripeObj: '' })} destroyOnClose={true}
        closeIcon={<FontAwesomeIcon className='modalCloseIcon' icon={faTimes} style={{ fontSize: 36 }} />}
        bodyStyle={{ padding: 0 }} 
        footer={<div style={{ display: 'flex', justifyContent: 'center' }}>
          <img className="custom2" src={require('./images/stripePowered.png')} alt='Powered by Stripe' 
          style={{ width: 125, height: 28, marginTop: 10 }} />
        </div>}>
          <Suspense fallback={<h1>Loading…</h1>}>
            <StripePage stripeObj={this.state.stripeObj} billingDetails={billingDetails} userId={userId} goToMovies={this.goToMovies} />
          </Suspense>
        </Modal>
        <Modal
          style={{ backgroundColor: COLORS.greenSuccess, marginTop: 100, paddingBottom: 0, borderRadius: 3 }}
          title={null}
          closable={true}
          closeIcon={<FontAwesomeIcon className='modalCloseIcon'icon={faTimes} style={{ fontSize: 36 }} />}
          footer={null}
          visible={modalPaymentCode===1}
          onOk={() => this.setModal2Visible(false)}
          onCancel={() => this.setModal2Visible(true)}
        >
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <FontAwesomeIcon color={COLORS.white} icon={faCheck} style={{ fontSize: 32 }} />
          </div>
          <p style={{ color: COLORS.white, textAlign:'center', fontFamily: 'OpenSans-Bold', marginTop: 12 }}>Payment  Successful</p>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button onClick={() => { this.setModal2Visible(false) }} className='caption' 
            style={{ display: "flex", alignItems: "center", justifyContent:'center', width: 200, height: 40, backgroundColor: COLORS.white, borderRadius: 3, margin: 10, opacity: 1 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                <h4 style={{ display: "flex", alignItems: "center", color: COLORS.greenSuccess, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                Checkout My Movies
                </h4>
              </div>
            </Button> 
          </div>
          <p style={{ color: COLORS.white, textAlign:'center', fontFamily: 'OpenSans-Bold', marginTop: 12 }}>Billing Support: billing@hit.movie</p>
        </Modal>
        <Modal
          style={{ backgroundColor: COLORS.redFail, marginTop: 100, paddingBottom: 0, borderRadius: 3 }}
          title={null}
          closable={true}
          closeIcon={<FontAwesomeIcon className='modalCloseIcon'icon={faTimes} style={{ fontSize: 36 }} />}
          footer={null}
          visible={modalPaymentCode===2}
          onOk={() => this.setModal2Visible(true)}
          onCancel={() => this.setModal2Visible(true)}
        >
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <FontAwesomeIcon color={COLORS.white} icon={faRetweet} style={{ fontSize: 32 }} />
          </div>
          <p style={{ color: COLORS.white, textAlign:'center', fontFamily: 'OpenSans-Bold', marginTop: 12 }}>Payment  Failed</p>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button onClick={() => { this.setModal2Visible(true) }} className='caption' 
            style={{ display: "flex", alignItems: "center", justifyContent:'center', width: 200, height: 40, backgroundColor: COLORS.white, borderRadius: 3, margin: 10, opacity: 1 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                <h4 style={{ display: "flex", alignItems: "center", color: COLORS.redFail, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                  Retry
                </h4>
              </div>
            </Button> 
          </div>
          <p style={{ color: COLORS.white, textAlign:'center', fontFamily: 'OpenSans-Bold', marginTop: 12 }}>Billing Support: billing@hit.movie</p>
        </Modal>
      </div>
    );
  };
};

export default Latest;